import {apiUrl} from '@/common/js/base.js';

export const oss = {

    // 获取应用配置
    getAppJson(obj,appId) {
        return $ajax({
        method: 'get',
        url: apiUrl.ossUrl + '/app/upload/json/'+ appId +'/app.json?timestamp=' + Math.floor(Date.now() / 60000),
        withCredentials:false,
        params:obj
        }).then(function (res) {
        return Promise.resolve(res.data)
        })
    },

    getIndexJson(obj,id,timeNo){
        return $ajax({
          method: 'get',
          url: apiUrl.ossUrl + '/entry/form/'+ timeNo +'/'+ id +'/index.json?timestamp=' + Math.floor(Date.now() / 60000),
          withCredentials:false,
          params:obj
        }).then(function (res) {
          return Promise.resolve(res.data)
        }).catch((err) => {
          return Promise.reject(err)
        })
    },

    //获取预览页面数据
    getJsonFromPreview(obj,id,timeNo){
        return $ajax({
            method: 'get',
            url: apiUrl.ossUrl + '/entry/form/'+ timeNo +'/'+ id +'/preview/index.json?timestamp=' + Math.floor(Date.now() / 60000),
            withCredentials:false,
            params:obj
        }).then(function (res) {
            return Promise.resolve(res.data)
        }).catch((err) => {
            return Promise.reject(err)
        })
    },

}



// WEBPACK FOOTER //
// ./src/api/basic/oss/index.js